"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ImageLibraryContext = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

var _signedUrlHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/signed-url-helper"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _imageLibraryDesktop = _interopRequireDefault(require("./views/image-library-desktop"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

require("./style/image-picker.scss");

var _authUploadHelper = _interopRequireDefault(require("./helpers/auth-upload-helper"));

var _imageLibraryHelper = require("./helpers/image-library-helper");

var _recoil = require("recoil");

var _store = require("./store");

var _hooks = require("./hooks");

var _reactQueryDevtools = require("react-query-devtools");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ImageLibraryContext = _react["default"].createContext();

exports.ImageLibraryContext = ImageLibraryContext;
var VIEWS = {
  SOCIAL: 'social',
  'FREE-IMAGES': 'free-images',
  'MY-IMAGES': 'my-images',
  'MY-LOGOS': 'my-logos',
  UPLOAD: 'upload'
};

var ImageLibrary = function ImageLibrary(_ref) {
  var visible = _ref.visible,
      setVisibility = _ref.setVisibility,
      returnValue = _ref.returnValue,
      onDelete = _ref.onDelete,
      setBase64ReturnValue = _ref.setBase64ReturnValue,
      useBase64Return = _ref.useBase64Return,
      preSearchQuery = _ref.preSearchQuery,
      type = _ref.type,
      tags = _ref.tags,
      useDetailsScreen = _ref.useDetailsScreen,
      extDisallowed = _ref.extDisallowed,
      dimensions = _ref.dimensions,
      uploadOnly = _ref.uploadOnly,
      showLogosTab = _ref.showLogosTab,
      logoTabByDefault = _ref.logoTabByDefault,
      logoMakerIntegrationUrl = _ref.logoMakerIntegrationUrl;

  var _useRecoilState = (0, _recoil.useRecoilState)(_store.loadingState),
      _useRecoilState2 = (0, _slicedToArray2["default"])(_useRecoilState, 2),
      loading = _useRecoilState2[0],
      setLoadingState = _useRecoilState2[1];

  var _useRecoilState3 = (0, _recoil.useRecoilState)(_store.state),
      _useRecoilState4 = (0, _slicedToArray2["default"])(_useRecoilState3, 2),
      globalState = _useRecoilState4[0],
      setGlobalState = _useRecoilState4[1];

  var _useActiveView = (0, _hooks.useActiveView)(),
      currentView = _useActiveView.currentView,
      setCurrentView = _useActiveView.setCurrentView,
      returnPage = _useActiveView.returnPage,
      setReturnPage = _useActiveView.setReturnPage;

  var _React$useState = _react["default"].useState([]),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      selection = _React$useState2[0],
      setSelection = _React$useState2[1];

  var _React$useState3 = _react["default"].useState([]),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      metaImages = _React$useState4[0],
      setMetaImages = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(null),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      selectedImage = _React$useState6[0],
      setSelectedImage = _React$useState6[1];

  var toggleLoading = function toggleLoading(state) {
    return setLoadingState({
      loading: state
    });
  };

  var setNewGlobalValue = function setNewGlobalValue(value) {
    return setGlobalState(function (oldValue) {
      return _objectSpread(_objectSpread({}, oldValue), value);
    });
  }; // Determine what tab to set to active.
  // Check what tab should be set initially and then again
  // when closing it.


  var determineActiveView = function determineActiveView() {
    if (returnPage && returnPage.length > 0) {
      return returnPage;
    }

    if (uploadOnly === true) {
      return VIEWS.UPLOAD;
    }

    if (logoTabByDefault) {
      return VIEWS['MY-LOGOS'];
    }

    return VIEWS['FREE-IMAGES'];
  };

  var localSetVisibility = function localSetVisibility() {
    var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setVisibility(bool);
  };

  var resetImageLibraryState = function resetImageLibraryState(cb) {
    toggleLoading(false);
    setSelection([]);
    setSelectedImage(null);
    setMetaImages([]);

    if (cb) {
      cb();
    }
  };

  var navigate = function navigate(e, view, metaFromFunc) {
    toggleLoading(false);

    if (metaFromFunc === null || metaFromFunc === void 0 ? void 0 : metaFromFunc.images) {
      setMetaImages(metaFromFunc.images);
    }

    if (metaFromFunc === null || metaFromFunc === void 0 ? void 0 : metaFromFunc.returnPage) {
      setReturnPage(metaFromFunc.returnPage);
    } else {
      setReturnPage(null);
    }

    if ((metaFromFunc === null || metaFromFunc === void 0 ? void 0 : metaFromFunc.selectedImage) || (metaFromFunc === null || metaFromFunc === void 0 ? void 0 : metaFromFunc.selectedImage) === 0) {
      setSelectedImage(metaFromFunc.selectedImage);
    }

    setCurrentView(view);
  };

  var showImageDetailsScreen = function showImageDetailsScreen(images) {
    setCurrentView('image-details');
    setSelection(images || selection);
  };

  var doSignedUpload = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(files) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
                  var token, storageEndpoint, signedFileUpload;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _authUploadHelper["default"].checkAuth();

                        case 2:
                          token = _context.sent;
                          storageEndpoint = (0, _urlHelper.getBaseUrl)('storage');
                          signedFileUpload = new _signedUrlHelper["default"](files, token, storageEndpoint, tags, function (progress, index, dimensions) {
                            if ((0, _typeof2["default"])(progress) === 'object') {
                              var url = progress.callBackResponse.image_url;
                              resolve([{
                                original: url,
                                thumbnail: url,
                                source: 'uploads'
                              }]);
                            }
                          }, function () {}, {
                            multipleAtOnce: true
                          }); // this still needs to handle the progress

                          signedFileUpload.initialize();

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2, _x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function doSignedUpload(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // File needs to be an array here, so [File]


  var uploadImages = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(file) {
      var signed;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return doSignedUpload([file]);

            case 2:
              signed = _context3.sent;
              return _context3.abrupt("return", signed);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function uploadImages(_x4) {
      return _ref4.apply(this, arguments);
    };
  }(); // if you edit an image, youll use this function to upload and then return the
  // value


  var onUseImagesBase64 = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(images) {
      var uploadImage, _selectedImage;

      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(useDetailsScreen && currentView !== 'image-details')) {
                _context4.next = 4;
                break;
              }

              showImageDetailsScreen(images);
              _context4.next = 13;
              break;

            case 4:
              toggleLoading(true);
              _context4.next = 7;
              return uploadImages(images[0]);

            case 7:
              uploadImage = _context4.sent;
              _selectedImage = selection[0];

              if ((_selectedImage === null || _selectedImage === void 0 ? void 0 : _selectedImage.source) === 'unsplash') {
                uploadImage[0].user = _selectedImage.user;
              }

              toggleLoading(false);
              returnValue(uploadImage);
              resetImageLibraryState(localSetVisibility);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onUseImagesBase64(_x5) {
      return _ref5.apply(this, arguments);
    };
  }(); // takes a base64 Image (still a blob at this point)


  var uploadEdittedImage = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(file) {
      var returnFile, newFile;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (file.base64) {
                returnFile = (0, _imageLibraryHelper.base64ImageToBlob)(file.base64);
                newFile = new File([returnFile], 'edit_image', {
                  type: returnFile.type
                });
                onUseImagesBase64([newFile]);
              }

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function uploadEdittedImage(_x6) {
      return _ref6.apply(this, arguments);
    };
  }(); // if you just selecting an image WITHOUT editting, youll go through here.


  var onUseImages = function onUseImages(images) {
    var returnNow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (useDetailsScreen && !returnNow) {
      showImageDetailsScreen();
    } else {
      var mappedImages = images ? [images] : selection;
      returnValue(mappedImages);
      resetImageLibraryState(localSetVisibility);
    }
  };

  var onSelectionChanged = function onSelectionChanged(selection, returnPage) {
    var returnNow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (returnNow) {
      onUseImages(selection, returnNow);
    } else {
      setReturnPage(returnPage);
      setSelection([selection]);
    }
  };

  _react["default"].useEffect(function () {
    if (selection && selection.length > 0) {
      onUseImages();
    }
  }, [selection]);

  _react["default"].useEffect(function () {
    var activeView = determineActiveView();
    setCurrentView(activeView);
  }, []);

  _react["default"].useEffect(function () {
    var activeView = determineActiveView();
    setCurrentView(activeView);
  }, [visible]);

  var addReferralToUrls = function addReferralToUrls(image) {
    var newImage = _objectSpread({}, image);

    Object.keys(newImage).forEach(function (key) {
      if (typeof newImage[key] === 'string' && newImage[key].indexOf('images.unsplash.com') > -1) {
        newImage[key] = "".concat(newImage[key], "&utm_source=endurance-innovation&utm_medium=referral");
      }

      if ((0, _isObject["default"])(newImage[key])) {
        Object.keys(newImage[key]).forEach(function (objKey) {
          if (typeof newImage[key][objKey] === 'string' && newImage[key][objKey].indexOf('images.unsplash.com') > -1) {
            newImage[key][objKey] = "".concat(newImage[key][objKey], "&utm_source=endurance-innovation&utm_medium=referral");
          }
        });
      }
    });
    return newImage;
  };

  var onSelect = function onSelect(image) {
    var addedReferrals = addReferralToUrls(image);
    returnValue([addedReferrals]);
    var newView = determineActiveView();
    setCurrentView(newView);
    resetImageLibraryState(localSetVisibility);
  };

  var setActionTop = function setActionTop(actions) {
    if (Array.isArray(actions)) {
      setNewGlobalValue({
        topActions: actions
      });
    }
  };

  var showAuthorDetails = function showAuthorDetails(_ref7) {
    var view = _ref7.view,
        meta = _ref7.meta;
    return navigate(null, view, meta);
  };

  return visible && /*#__PURE__*/_react["default"].createElement(ImageLibraryContext.Provider, {
    value: {
      navigate: navigate,
      onSelectionChanged: onSelectionChanged,
      setSelectedImage: setSelectedImage,
      selectedImage: selectedImage,
      setVisibility: setVisibility,
      setBase64ReturnValue: setBase64ReturnValue,
      onUseImagesBase64: onUseImagesBase64,
      onUseImages: onUseImages,
      resetImageLibraryState: resetImageLibraryState,
      uploadEdittedImage: uploadEdittedImage,
      useBase64Return: useBase64Return,
      tags: tags,
      preSearchQuery: preSearchQuery,
      selection: selection,
      returnValue: returnValue,
      onDelete: onDelete,
      type: type,
      useDetailsScreen: useDetailsScreen,
      dimensions: dimensions,
      uploadOnly: uploadOnly,
      toggleLoading: toggleLoading,
      loading: loading.loading,
      topActions: globalState.topActions,
      setActionTop: setActionTop,
      onSelect: onSelect,
      showAuthorDetails: showAuthorDetails,
      metaImages: metaImages,
      setMetaImages: setMetaImages,
      returnPage: returnPage,
      logoMakerIntegrationUrl: logoMakerIntegrationUrl,
      showLogosTab: showLogosTab,
      extDisallowed: extDisallowed
    }
  }, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"], {
    open: visible,
    maxWidth: "lg",
    height: "80vh",
    variant: "light",
    onClose: localSetVisibility,
    dataElementPrefix: "image-selector-modal",
    processing: loading.loading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "image-picker-container visible"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _mobileDetectionHelper["default"])() ? 'ip-wrapper mobile' : 'ip-wrapper'
  }, /*#__PURE__*/_react["default"].createElement(_imageLibraryDesktop["default"], null)))), /*#__PURE__*/_react["default"].createElement(_reactQueryDevtools.ReactQueryDevtools, {
    initialIsOpen: true
  }));
};

ImageLibrary.propTypes = {
  visible: _propTypes["default"].bool.isRequired,
  setVisibility: _propTypes["default"].func.isRequired,
  returnValue: _propTypes["default"].func.isRequired,
  onDelete: _propTypes["default"].func,
  setBase64ReturnValue: _propTypes["default"].func,
  useBase64Return: _propTypes["default"].bool,
  preSearchQuery: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['videos', 'images']),
  tags: _propTypes["default"].object,
  useDetailsScreen: _propTypes["default"].bool,
  // useSocialSearch: PropTypes.bool,
  dimensions: _propTypes["default"].array,
  uploadOnly: _propTypes["default"].bool,
  showLogosTab: _propTypes["default"].bool,
  logoTabByDefault: _propTypes["default"].bool,
  logoMakerIntegrationUrl: _propTypes["default"].bool,
  extDisallowed: _propTypes["default"].any
};
var _default = ImageLibrary;
exports["default"] = _default;